import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const STATUS_COLORS = {
  Open: "#dc2626",
  Closed: "#059669",
  Waiting: "#d97706",
};
const STATUS_BG = {
  Open: "#fef2f2",
  Closed: "#ecfdf5",
  Waiting: "#fffbeb",
};

export default function StatusDonut({ data }) {
  if (!data || data.length === 0) return null;

  const total = data.reduce((s, d) => s + d.value, 0);

  return (
    <div className="corp-card animate-fade-slide-up" style={{ animationDelay: "350ms" }} data-testid="status-donut-chart">
      <div className="h-1 w-full bg-[#059669]" />
      <div className="p-6">
        <div className="mb-4">
          <h3 className="text-base font-bold text-slate-800">Status Overview</h3>
          <p className="text-xs text-slate-400 mt-0.5">Current ticket distribution</p>
        </div>

        <div className="relative">
          <ResponsiveContainer width="100%" height={180}>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={55}
                outerRadius={80}
                paddingAngle={3}
                dataKey="value"
                startAngle={90}
                endAngle={-270}
              >
                {data.map((entry) => (
                  <Cell key={entry.name} fill={STATUS_COLORS[entry.name] || '#94a3b8'} stroke="white" strokeWidth={3} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="text-center">
              <div className="text-3xl font-black text-slate-800">{total}</div>
              <div className="text-[10px] text-slate-400 font-semibold uppercase tracking-wider">Total</div>
            </div>
          </div>
        </div>

        <div className="flex justify-center gap-4 mt-4">
          {data.map((item) => (
            <div key={item.name} className="flex items-center gap-2 px-3 py-1.5 rounded-lg" style={{ backgroundColor: STATUS_BG[item.name] || '#f8fafc' }}>
              <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: STATUS_COLORS[item.name] || '#94a3b8' }} />
              <span className="text-xs font-medium" style={{ color: STATUS_COLORS[item.name] }}>{item.name}</span>
              <span className="text-xs font-bold" style={{ color: STATUS_COLORS[item.name] }}>{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
